export const handleChangeDataModalErrorMsg = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_ERROR_MSG', name, value
});